import React from 'react';
import './Banner.css';

const Banner = () => {
    return (
        <div className='banner'>
            <div className="container">
                <div className="row cusrow">
                    <div className="col-sm-6 cushea">
                        <h2 className='cush' >Hi , I am the  Professional Photographer</h2>
                        <p>Capturing life’s cherished moments is what we love to do. Weddings, Party & Corporate occasion is my best service. I love working with people and making them look their best. My photos will capture the joy and happiness of your special day!</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Banner;